module.exports = __webpack_public_path__ + "static/media/whatif.0bee47c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/whatif.svg
// module id = 108
// module chunks = 0